export const getObjectKeys = (o: Object, parentPath = ""): string[] => {
  const prefix = parentPath ? `${parentPath}.` : "";

  return Object.entries(o || {})
    .map(([ key, value ]) => {
      const propertyPath = `${prefix}${key}`;
      if (Array.isArray(value)) {
        return value.map((v, i) => getObjectKeys(v, `${propertyPath}[${i}]`))
          .reduce((acc, val) => [ ...acc, ...val ], []);
      }
      if (typeof value === "object") {
        return [ ...getObjectKeys(value, propertyPath) ];
      }
      return [ propertyPath ];
    })
    .reduce((acc, val) => [ ...acc, ...val ], []);
};